var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-dialog-section"},[(_vm.title.length > 0)?_c('Label',{attrs:{"label":_vm.title}}):_vm._e(),(_vm.loading)?_c('InlineLoader'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }